import { useState, useEffect, useRef, useCallback } from 'react';
import useCreateOrUpdateAffordaPortalFormsMutation from './useCreateOrUpdateAffordaPortalFormsMutation';
import useDeleteAffordaPortalFormMutation from './useDeleteAffordaPortalFormMutation';
import useAffordaPortalFormsQuery from './useAffordaPortalFormsQuery';
import { INITIAL_STATE } from 'hooks/affordaPortalFormState/constants';
import useEnableFormStateLogging from 'hooks/affordaPortalFormState/useEnableFormStateLogging';

const useFormStateData = () => {
  const { isFormStateLoggingEnabled } = useEnableFormStateLogging();
  const shouldUpdateDB = useRef(true);
  const hasInitialized = useRef(false);
  const [state, setState] = useState(INITIAL_STATE);
  const { isFetched } = useAffordaPortalFormsQuery({
    options: {
      onSuccess: (response) => {
        const hasData = !!response.id;
        if (!hasData) return;

        if (isFormStateLoggingEnabled) {
          console.group('useFormStateData.DB.response');
          console.log(response);
          console.groupEnd();
        }
        if (hasInitialized.current === true) return;

        if (isFormStateLoggingEnabled) {
          console.group('useFormStateData.Initialized');
          console.log(response);
          console.groupEnd();
        }

        hasInitialized.current = true;
        shouldUpdateDB.current = false;

        setState(response);
      },
    },
  });

  const { mutate } = useCreateOrUpdateAffordaPortalFormsMutation();
  const { mutate: deleteForm } = useDeleteAffordaPortalFormMutation();

  const update = useCallback(
    (newState) => {
      setState((prevState) => {
        const stateUpdate =
          typeof newState === 'function' ? newState(prevState) : newState;

        if (isFormStateLoggingEnabled) {
          console.group('useFormStateData.Update');
          console.log('Updates', stateUpdate);

          console.groupEnd();
        }

        return stateUpdate;
      });
    },
    [isFormStateLoggingEnabled],
  );

  // Update DB when state changes
  useEffect(() => {
    if (!isFetched) return;
    // return the first update when state initializes
    if (!shouldUpdateDB.current) {
      shouldUpdateDB.current = true;
      return;
    }

    if (isFormStateLoggingEnabled) {
      if (state.id === INITIAL_STATE.id) {
        // todo keep from updating if going to overwrite existing values
        console.error('Cannot update DB with initial state');
        // return;
      }
      console.group('useFormStateData.DB Update');
      console.log(state);
      console.groupEnd();
    }
    mutate(state);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mutate, state]);

  return { data: state, update, deleteForm };
};

export default useFormStateData;
